const siteUrl = 'https://www.pathwayhyundai.com/'

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: 'Hyundai',
    siteUrl:'https://www.pathwayhyundai.com/',
    site_id: '681ccfc726f9aad88b10e57b',
    api_base_url: 'https://api.dealermasters.com:4500',
    lead_url: 'https://leads.dealermasters.com/leads',
    master_sites: [],
    autocheck_url: 'https://n1u6ywp1bf.execute-api.us-east-2.amazonaws.com/default/AutoCheckFastLink',
      quickgenAPI: 'https://dev.mxsapi.com',
      imageBaseURL: 'https://images.mxssolutions.com'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    {
      resolve: "gatsby-plugin-force-trailing-slashes"
    },
    {
      resolve: 'gatsby-plugin-advanced-sitemap',
      options: {
        exclude: ["/dev-404-page", "/404", "/404.html", "/offline-plugin-app-shell-fallback", "/dm-preview"]
      },
    },
    {
      resolve: "gatsby-plugin-emotion"
    },
    {
      resolve: "gatsby-transformer-json"
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        cssLoaderOptions: {
          camelCase: false,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `src`,
        path: `${__dirname}/src/`
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: 'mxs-b9a7353b-016b-4446-9695-c0aa2ea8eff2-prodsite'
      }
    },
    `gatsby-transformer-json`,
    {
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'inventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['114523']//126024
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'static/favicon.png'
      }
    },{
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://www.pathwayhyundai.com/',
        sitemap: 'https://www.pathwayhyundai.com/sitemap-pages.xml',
        policy: [{ userAgent: '*', allow: '/' }]
      }
    }
  ]
}